import { Box, Card } from '@mui/material'
import Image from 'next/image'
import { useMemo } from 'react'
import { GetHomeScreenQuery } from '~/__generated__/graphql'
import { DurationLabel } from '~/components/DurationLabel'
import { UpComingChip } from '~/features/play_list/components/chips'
import { useMediaQuery } from '~/hooks/useMediaQuery'
import { thumbnailPlaceholder } from '~/libs/constants'
import { Colors } from '~/libs/mui/color'
import { getVideoWatchedPercent } from '~/libs/video/getVideoWatchedPercent'
import { getSizeStyle } from './getSizeStyle'

type VideoItemCardProps = {
  video: NonNullable<GetHomeScreenQuery['homeScreens'][0]['videos']>[0]
  fullWidth?: boolean
  onClickCard: () => void
}

export const VideoItemCard = ({ video, fullWidth = false, onClickCard }: VideoItemCardProps) => {
  const { isSm } = useMediaQuery()
  const sizeStyle = useMemo(() => getSizeStyle(fullWidth), [fullWidth])
  const watchedPercent = useMemo(() => {
    if (!video.viewingTime) return undefined
    return getVideoWatchedPercent(
      { minutes: video.duration?.minutes ?? 0, seconds: video.duration?.seconds ?? 0 },
      { minutes: video.viewingTime.viewingMin ?? 0, seconds: video.viewingTime.viewingSecond ?? 0 },
    )
  }, [video])
  const isUpComing = video.status === 'upcoming'
  const isEndsSoon = useMemo(() => {
    return (
      video.willBeUnpublishedAt &&
      new Date(video.willBeUnpublishedAt).getTime() - 1000 * 60 * 60 * 24 * 30 <= Date.now() // 30日以内に配信終了
    )
  }, [video.willBeUnpublishedAt])
  return (
    <Box>
      <Card
        sx={{
          position: 'relative',
          cursor: 'pointer',
          ...sizeStyle,
        }}
        onClick={onClickCard}
      >
        <Image
          alt='thumbnail'
          src={isSm ? video.landscapeThumbnail ?? '' : video.portraitThumbnail ?? ''}
          fill
          sizes='25vw'
          style={{
            objectFit: 'cover',
            pointerEvents: 'none',
            userSelect: 'none',
          }}
          placeholder='blur'
          blurDataURL={thumbnailPlaceholder}
        />
        {isUpComing && <UpComingChip />}
        <Box position='absolute' top={2} right={2}>
          <DurationLabel
            durationMinute={video.duration?.minutes ?? 0}
            durationSecond={video.duration?.seconds ?? 0}
          />
        </Box>
        {!!watchedPercent && (
          <Box
            position='absolute'
            bottom={0}
            left={0}
            height='3px'
            width={`${watchedPercent * 100}%`}
            sx={{ backgroundColor: Colors.red, borderRadius: '1px' }}
          />
        )}
      </Card>
    </Box>
  )
}
